import { useEffect } from 'react';
import { useAgreements } from './useAgreements';
import { useAgreementStore } from '../store/agreementStore';
import { useAgreements as useLegacyContext } from '@/context/AgreementsContext';

export function useAgreementHydration(): void {
  const { data: agreements, isLoading } = useAgreements();
  const { activeAgreement, activeAgreementUuid, setActiveAgreement, clearActiveAgreement } =
    useAgreementStore();
  const { setActiveAgreement: bridgeLegacyContext } = useLegacyContext();

  useEffect(() => {
    if (isLoading || !agreements?.length) return;
    if (!activeAgreementUuid || activeAgreement) return;

    const found = agreements?.find((a) => a.uuid === activeAgreementUuid) ?? null;
    if (found) {
      setActiveAgreement(found);
      bridgeLegacyContext(found);
    } else {
      clearActiveAgreement();
    }
  }, [isLoading, agreements, activeAgreementUuid, activeAgreement, setActiveAgreement, clearActiveAgreement, bridgeLegacyContext]);
}
